import { Space, Tooltip } from "antd";
import { FONT } from "constants/index";
import { ArrowRightToLine, UserRoundPen, UserRoundX } from "lucide-react";

const types = {
  ESPORTIVO: "Centro Esportivo",
  AQUATICO: "Centro Aquatico",
};
export const Columns = (innerWidth) => {
  const table = [
    {
      title: "ID",
      dataIndex: "id",
      textWrap: "word-break",
      ellipsis: true,
      width: "10%",
    },
    {
      title: "Nome",
      dataIndex: "name",
      textWrap: "word-break",
      ellipsis: true,
      width: "10%",
    },
    {
      title: "Administrador",
      dataIndex: "ownerName",
      textWrap: "word-break",
      ellipsis: true,
      width: "10%",
    },
    {
      title: "Tipo",
      dataIndex: "role",
      textWrap: "word-break",
      ellipsis: true,
      width: "10%",
      render: (text) => {
        return types[text];
      },
    },
  ];

  table.push({
    title: "Ações",
    dataIndex: "action",
    width: "10%",
    render: (text, row) => {
      return (
        <Space size="middle">
          <Tooltip style={{ fontFamily: FONT }} title="Editar Unidade">
            <UserRoundPen
              onClick={() => row.edit(row)}
              size={22}
              style={{ cursor: "pointer", color: "#09ac9c" }}
            />
          </Tooltip>
          {/*  <Tooltip style={{ fontFamily: FONT }} title="Desativar Unidade">
            <UserRoundX
              onClick={() => row.delete(row)}
              size={22}
              style={{ cursor: "pointer", color: "#EC6D62" }}
            />
          </Tooltip>

          */}
          <Tooltip style={{ fontFamily: FONT }} title="Acessar Unidade">
            <ArrowRightToLine
              onClick={() => row.changeBranch(row)}
              size={22}
              style={{ cursor: "pointer", color: "#EC6D62" }}
            />
          </Tooltip>
        </Space>
      );
    },
  });
  return table;
};
